import { render, staticRenderFns } from "./PaymentMethodDetail.vue?vue&type=template&id=47c3759e&scoped=true"
import script from "./PaymentMethodDetail.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodDetail.vue?vue&type=script&lang=ts"
import style0 from "./PaymentMethodDetail.vue?vue&type=style&index=0&id=47c3759e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3759e",
  null
  
)

export default component.exports